var PropertyMetadata = /** @class */ (function () {
    function PropertyMetadata(propertyName, propertyValue, propertyType, type) {
        this.propertyName = propertyName;
        this.propertyValue = propertyValue;
        this.propertyType = propertyType;
        this.type = type;
    }
    Object.defineProperty(PropertyMetadata.prototype, "isIdentifierReference", {
        get: function () {
            return this.type === 'identifierReference';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PropertyMetadata.prototype, "isIdentifierReferenceArray", {
        get: function () {
            return this.type === 'identifierReferenceArray';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PropertyMetadata.prototype, "isModel", {
        get: function () {
            return this.type === 'model';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PropertyMetadata.prototype, "isModelArray", {
        get: function () {
            return this.type === 'modelArray';
        },
        enumerable: false,
        configurable: true
    });
    return PropertyMetadata;
}());
export default PropertyMetadata;
//# sourceMappingURL=PropertyMetadata.js.map